import { PuckDataProvider } from "./PuckDataProvider";

export function withContexts<P extends object>(Component: React.ComponentType<P>) {
    const WithContexts = (props: P) => {
        return (
            <PuckDataProvider>
                <Component {...props} />
            </PuckDataProvider>
        );
    };

    const displayName = Component.displayName || Component.name || "Component";
    WithContexts.displayName = `withContexts(${displayName})`;

    return WithContexts;
}
